import React from "react";
import Service from "./Service";

const Services = () => {
  return (
    <div className=" w-full px-5 md:px-20  mx-auto py-2">
      <div>
        <div className="flex items-center justify-center my-4 space-x-4">
          {/* <h6 className=" text-lg text-white">MY</h6> */}
          <h6 className="text-green-500 font-bold font-roboto text-3xl ">
            &lt; MY SERVICES / &gt;
          </h6>
        </div>
        <div className="flex w-full justify-center items-center">
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
          <span className="mx-2"></span>
          <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[50px] my-10">
          <Service
            category={"FRONTEND DEVELOPMENT"}
            jobTitle={"Pixel Perfect Landing, SPA or Dashboard Development"}
            description={
              "I specialize in converting Figma designs into pixel-perfect, responsive web components, SPAs, and dashboards using modern technologies like Vue.js. With a keen eye for detail and a focus on performance and cross-browser compatibility, I ensure seamless and high-quality implementations. Let's turn your designs into stunning, functional web experiences!"
            }
          ></Service>
          <Service
            category={"BACKEND DEVELOPMENT"}
            jobTitle={"Backend API and Database Development"}
            description={
              "I specialize in building robust, scalable backend systems and APIs using Python and PHP. With expertise in database design and management (SQL and NoSQL), I ensure secure, efficient, and maintainable backend solutions. Let's create powerful server-side applications to drive your project's success!"
            }
          ></Service>
          <Service
            category={"FULL STACK DEVELOPMENT"}
            jobTitle={"Full Stack Web Developer"}
            description={
              "I specialize in developing complete web applications from scratch using modern technologies. Proficient in both frontend (HTML, CSS, JavaScript, React, Vue.js) and backend (Python, PHP) development, I ensure seamless integration and performance. Let's build dynamic, responsive, and scalable web solutions to meet your business needs!"
            }
          ></Service>
          <Service
            category={"REST API DEVELOPMENT"}
            jobTitle={"REST API Developer"}
            description={
              "I specialize in designing and developing robust RESTful APIs using Python and PHP. With a focus on scalability, security, and performance, I ensure seamless data exchange and integration for your applications. Let's build reliable APIs to power your digital solutions!"
            }
          ></Service>
          <Service
            category={"PROJECT MANAGEMENT"}
            jobTitle={"Project Manager"}
            description={
              "I specialize in leading projects to success with effective planning, coordination, and execution. With strong skills in team collaboration, risk management, and resource allocation, I ensure timely and within-budget delivery of high-quality results. Let's drive your projects to successful completion!"
            }
          ></Service>
          <Service
            category={"BUG FIX"}
            jobTitle={"Error DEBUGGING"}
            description={
              "I specialize in identifying, troubleshooting, and resolving software bugs efficiently. With expertise in debugging across various programming languages and frameworks, I ensure your applications run smoothly and reliably. Let's eliminate bugs and enhance the performance of your software!"
            }
          ></Service>
        </div>
      </div>
    </div>
  );
};

export default Services;
